import React from 'react'
import { CloseIcon, DeleteIcon } from '@/assets/icons'
import { useOverlayDismiss } from '@hooks'
import {
	CloseButton,
	DeleteButton,
	ModalBackdrop,
	ModalBody,
	ModalContainer,
	ModalFooter,
	ModalHeader,
	ModalHeaderActions,
	ModalTitle,
} from './Modal.styles'

export { DeleteButton } from './Modal.styles'

interface ModalProps {
	isOpen: boolean
	onClose: () => void
	title: string
	children: React.ReactNode
	footer?: React.ReactNode
	showCloseButton?: boolean
	size?: 'small' | 'medium' | 'large'
	closeOnBackdropClick?: boolean
	backgroundColor?: string
	onDelete?: () => void
}

const Modal: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	title,
	children,
	footer,
	showCloseButton = true,
	size = 'medium',
	closeOnBackdropClick = true,
	backgroundColor,
	onDelete,
}) => {
	// Esc-to-close + body scroll lock, shared across the app's modals.
	useOverlayDismiss(isOpen, onClose)

	const handleBackdropClick = (e: React.MouseEvent) => {
		if (closeOnBackdropClick && e.target === e.currentTarget) {
			onClose()
		}
	}

	if (!isOpen) return null

	return (
		<ModalBackdrop onClick={handleBackdropClick}>
			<ModalContainer size={size} backgroundColor={backgroundColor}>
				<ModalHeader>
					<ModalTitle>{title}</ModalTitle>
					<ModalHeaderActions>
						{onDelete && (
							<DeleteButton onClick={onDelete} title="Delete">
								<DeleteIcon />
							</DeleteButton>
						)}
						{showCloseButton && (
							<CloseButton onClick={onClose} aria-label="Close">
								<CloseIcon sx={{ fontSize: 22 }} />
							</CloseButton>
						)}
					</ModalHeaderActions>
				</ModalHeader>
				<ModalBody>{children}</ModalBody>
				{footer && <ModalFooter>{footer}</ModalFooter>}
			</ModalContainer>
		</ModalBackdrop>
	)
}

export default Modal
